const adaptEstimatedSigning = (value) => {
  if (!value) return { value: "not_scheduled", title: "Not scheduled" };

  return { value: "scheduled", title: value };
};

export const adaptError = (error) => {
  if (!error?.response?.data?.message) {
    return {
      message: "Unknown error occurred. Please try again later",
    };
  }

  return error.response.data;
};

export const adaptBlueprintStage = (data) => {
  const errors = data?.meta?.errors;
  if (errors?.length) {
    const error = errors[0];
    return {
      crmTransactionStatus: "error",
      errorTitle: error.title || "Status temporarily unavailable",
      errorMessage: error.title
        ? error.message
        : "Try again in a few minutes, or check the Blueprint portal directly.",
    };
  }

  const stage = data?.stage;
  if (!stage) return null;

  const status = stage.crm_transaction_status;
  const isReadyToClose = status === "ready_to_close";
  const isPostClosing = status === "post_closing";
  const postClosingCard = isPostClosing ? stage.milestones?.find((m) => m.key === "post_closing") : null;

  return {
    crmTransactionStatus: status,
    badge: stage.badge,
    crmDescription: stage.crm_description,
    lastUpdated: stage.last_updated,
    escrowOfficer: stage.escrow_officer,
    estimatedSigning: isReadyToClose ? adaptEstimatedSigning(stage.estimated_signing) : null,
    cdaStatus: isPostClosing ? stage.cda_status : null,
    titleStatus: isPostClosing ? null : stage.title_status,
    earnestMoneyStatus: isReadyToClose || isPostClosing ? null : stage.earnest_money_status,
    fundingStatus: isPostClosing ? stage.funding_status : null,
    recordingStatus: isPostClosing ? stage.recording_status : null,
    primaryMilestone: stage.primary_milestone && {
      ...stage.primary_milestone,
      title: postClosingCard?.title || stage.primary_milestone.title,
      description: postClosingCard?.description || stage.primary_milestone.description,
      status: stage.primary_milestone.status !== "completed" ? "in_progress" : stage.primary_milestone.status,
    },
    milestones: stage.milestones?.map((m) => {
      const isActiveMilestone = isPostClosing
        ? m.key === "post_closing"
        : m.key === stage.primary_milestone?.key;

      return {
        ...m,
        status: isActiveMilestone && m.status !== "completed" ? "in_progress" : m.status,
      };
    }),
    progress: stage.progress,
    errorTitle: stage.error_title || null,
    errorMessage: stage.error_message || null,
  };
};
